import Grid from "@mui/material/Grid";
import ScorecardNameFilters from "./ScorecardNameFilters/ScorecardNameFilters";
import React from "react";
import ChannelFilters from "./ChannelFilters/ChannelFilters";
import TypeFilters from "./TypeFilters/TypeFilters";
import ActiveStatusFilters from "./ActiveStatusFilters/ActiveStatusFilters";
import ScorecardFiltersViewModel from "../Viewmodels/ScorecardFiltersViewModel";
import ClientFilters from "./ClientFilters/ClientFilters";

interface IScorecardManagementFiltersProps {
    filters: ScorecardFiltersViewModel
    changeFilter: (filterName: keyof ScorecardFiltersViewModel, newValue: any) => void;
}

export default function ScorecardManagementFilters({ filters, changeFilter }: IScorecardManagementFiltersProps) {
    return (
        <>
            <Grid>
                <ScorecardNameFilters name={filters.name} changeFilter={changeFilter} />
            </Grid>
            <Grid>
                <ClientFilters client={filters.client} changeFilter={changeFilter} />
            </Grid>
            <Grid>
                <ChannelFilters client={filters.client} channel={filters.channel} changeFilter={changeFilter} />
            </Grid>
            <Grid>
                <TypeFilters type={filters.type} changeFilter={changeFilter} />
            </Grid>
            <Grid>
                <ActiveStatusFilters activeStatus={filters.activeStatus} changeFilter={changeFilter} />
            </Grid>
        </>
    )
}